export const Challenge_Toasts_DA = {
  // Toasts used for challenges
  challengeToasts: {
    joined: "Du deltager nu",
    request: "Anmodning om at deltage er under behandling",
    error: "Noget gik galt, da du prøvede at deltage i udfordringen",
    errorPlatform:
      "Kunne ikke deltage i udfordringen, sørg for, at du er tilsluttet den korrekte platform for dette spil",
    notFound: "Kunne ikke finde udfordringen at deltage i",
    addAccount: "Tilføj konto",
  },
};
